///**debut original */
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { enableProdMode } from '@angular/core';
// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';
// import * as Sentry from '@sentry/angular';

// let DSN_DEV =
//   'https://9b0f8633439f0da5e25632ceb94eb542@o4507343120891904.ingest.us.sentry.io/4507343127576576';
// let DSN_PROD =
//   'https://0ad873450a10929da7d59a4e5904a16d@o4507357313302528.ingest.de.sentry.io/4507357327786064';

// if (environment.production) {
//   enableProdMode();
// }

// Sentry.init({
//   dsn: environment.production ? DSN_PROD : DSN_DEV,
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .catch((err) => console.error(err));
///**finoriginal*/
/***************************************** */
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { enableProdMode } from '@angular/core';
// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';

// const DSN_DEV =
//   'https://9b0f8633439f0da5e25632ceb94eb542@o4507343120891904.ingest.us.sentry.io/4507343127576576';
// const DSN_PROD =
//   'https://0ad873450a10929da7d59a4e5904a16d@o4507357313302528.ingest.de.sentry.io/4507357327786064';

// if (environment.production) {
//   enableProdMode();
// }

// // ===== SOLUTION 1: CHARGEMENT ASYNCHRONE APRÈS BOOTSTRAP (RECOMMANDÉE) =====
// async function initSentryAsync() {
//   try {
//     const Sentry = await import('@sentry/angular');

//     Sentry.init({
//       dsn: environment.production ? DSN_PROD : DSN_DEV,
//       environment: environment.production ? 'production' : 'development',

//       // ⚡ OPTIMISATIONS PERFORMANCE CRITIQUES
//       integrations: [
//         Sentry.browserTracingIntegration(),
//         // Désactiver le replay en production pour la performance
//         ...(environment.production ? [] : [Sentry.replayIntegration()]),
//       ],

//       // 🎯 ÉCHANTILLONNAGE OPTIMISÉ
//       tracesSampleRate: environment.production ? 0.1 : 1.0, // 10% en prod au lieu de 100%

//       // 🚀 CONFIGURATION POUR ÉVITER LES REQUÊTES BLOQUANTES
//       // Note: timeout n'est pas disponible dans toutes les versions de Sentry
//       // Utiliser beforeSend pour contrôler les performances à la place

//       // 📊 REPLAY CONFIGURATION OPTIMISÉE
//       replaysSessionSampleRate: environment.production ? 0.01 : 0.1, // 1% en prod
//       replaysOnErrorSampleRate: environment.production ? 0.1 : 1.0, // 10% en prod

//       // 🔧 AUTRES OPTIMISATIONS
//       maxBreadcrumbs: 50,
//       debug: !environment.production,
//       sendDefaultPii: false,
//       attachStacktrace: !environment.production, // Désactiver en prod

//       // 🎯 FILTRAGE DES ERREURS POUR RÉDUIRE LE TRAFIC
//       beforeSend(event) {
//         // Filtrer les erreurs non critiques
//         if (event.exception?.values?.[0]?.value?.includes('Non-Error')) {
//           return null;
//         }

//         // Filtrer les erreurs réseau temporaires
//         if (event.exception?.values?.[0]?.value?.includes('NetworkError')) {
//           return null;
//         }

//         return event;
//       },

//       // 🎯 FILTRAGE DES TRANSACTIONS
//       beforeSendTransaction(event) {
//         // Filtrer les transactions trop longues (plus de 30s)
//         if (event.timestamp && event.start_timestamp) {
//           const duration = event.timestamp - event.start_timestamp;
//           if (duration > 30) {
//             return null;
//           }
//         }
//         return event;
//       },

//       // 🌐 CONFIGURATION RÉSEAU OPTIMISÉE
//       tracePropagationTargets: environment.production
//         ? ['yourserver.io'] // Limiter aux domaines nécessaires en prod
//         : ['localhost', /^https:\/\/yourserver\.io\/api/],
//     });

//     // console.log('Sentry initialized successfully');
//   } catch (error) {
//     console.warn('Sentry initialization failed:', error);
//   }
// }

// // Bootstrap de l'application SANS attendre Sentry
// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .then(() => {
//     // Initialiser Sentry APRÈS le bootstrap pour éviter le blocage
//     initSentryAsync();
//   })
//   .catch((err) => console.error(err));
/**************************** */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const DSN_DEV =
  'https://9b0f8633439f0da5e25632ceb94eb542@o4507343120891904.ingest.us.sentry.io/4507343127576576';
const DSN_PROD =
  'https://0ad873450a10929da7d59a4e5904a16d@o4507357313302528.ingest.de.sentry.io/4507357327786064';

if (environment.production) {
  enableProdMode();
}

// ===== SOLUTION OPTIMISÉE: CHARGEMENT DIFFÉRÉ AVEC TIMEOUT =====
function initSentryWithTimeout() {
  // Délai de 2 secondes pour laisser la page se charger d'abord
  setTimeout(async () => {
    try {
      const Sentry = await import('@sentry/angular');

      Sentry.init({
        dsn: environment.production ? DSN_PROD : DSN_DEV,
        environment: environment.production ? 'production' : 'development',

        // ⚡ OPTIMISATIONS PERFORMANCE CRITIQUES
        integrations: [
          Sentry.browserTracingIntegration({
            // Réduire le tracing automatique
            enableLongAnimationFrame: false,
            enableInp: false,
          }),
          // Complètement désactiver le replay qui consomme beaucoup
          // ...(environment.production ? [] : [Sentry.replayIntegration()]),
        ],

        // 🎯 ÉCHANTILLONNAGE TRÈS RÉDUIT
        tracesSampleRate: environment.production ? 0.05 : 0.3, // 5% en prod, 30% en dev

        // 📊 REPLAY COMPLÈTEMENT DÉSACTIVÉ POUR LA PERFORMANCE
        replaysSessionSampleRate: 0, // Désactivé
        replaysOnErrorSampleRate: environment.production ? 0.05 : 0.1, // Minimal

        // 🔧 OPTIMISATIONS RÉSEAU
        maxBreadcrumbs: 20, // Réduit de 50 à 20
        debug: false, // Toujours désactivé pour la performance
        sendDefaultPii: false,
        attachStacktrace: false, // Désactivé pour la performance

        // 🚀 TRANSPORT OPTIMISÉ
        transport: Sentry.makeBrowserOfflineTransport(
          Sentry.makeFetchTransport
        ),

        // 🎯 FILTRAGE AGRESSIF DES ERREURS
        beforeSend(event) {
          // Filtrer encore plus d'erreurs non critiques
          const errorValue = event.exception?.values?.[0]?.value || '';

          // Liste étendue d'erreurs à ignorer
          const ignoredErrors = [
            'Non-Error',
            'NetworkError',
            'ChunkLoadError',
            'Loading chunk',
            'Script error',
            'ResizeObserver loop limit exceeded',
            'timeout',
          ];

          if (ignoredErrors.some((ignore) => errorValue.includes(ignore))) {
            return null;
          }

          return event;
        },

        // 🎯 FILTRAGE DES TRANSACTIONS
        beforeSendTransaction(event) {
          // Filtrer les transactions longues et non critiques
          if (event.timestamp && event.start_timestamp) {
            const duration = event.timestamp - event.start_timestamp;
            if (duration > 10) {
              // Réduit de 30s à 10s
              return null;
            }
          }

          // Filtrer certaines transactions non critiques
          const transactionName = event.transaction || '';
          if (
            transactionName.includes('idle') ||
            transactionName.includes('navigation')
          ) {
            return null;
          }

          return event;
        },

        // 🌐 CONFIGURATION RÉSEAU TRÈS RESTRICTIVE
        tracePropagationTargets: environment.production
          ? [] // Complètement désactivé en production
          : ['localhost'],

        // 🎯 DÉSACTIVER LE TRACING AUTOMATIQUE DES REQUÊTES
        enableTracing: false,
      });

      // console.log('Sentry initialized asynchronously');
    } catch (error) {
      console.warn('Sentry initialization failed (non-blocking):', error);
    }
  }, 2000); // Délai de 2 secondes
}

// ===== ALTERNATIVE: CHARGEMENT CONDITIONNEL =====
function conditionalSentryInit() {
  // Ne charger Sentry que si nécessaire
  if (environment.production && Math.random() > 0.9) {
    // Seulement 10% du temps en production
    initSentryWithTimeout();
  } else if (!environment.production) {
    // En développement, délai plus long
    setTimeout(() => initSentryWithTimeout(), 5000);
  }
}

// Bootstrap de l'application SANS Sentry
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // Attendre que la page soit complètement interactive
    if (document.readyState === 'complete') {
      initSentryWithTimeout();
    } else {
      window.addEventListener('load', initSentryWithTimeout);
    }
  })
  .catch((err) => console.error(err));
